// Module
var code = "<ng2-bm-ng-select [items]=\"vm.items\" [selected]=\"vm.selected\" [clearable]=\"false\" [multiple]=\"false\" [group-by]=\"'country'\" [placeholder]=\"'Select a timezone'\" (change-selected)=\"vm.onChangeSelected($event)\"> </ng2-bm-ng-select> ";
// Exports
module.exports = code;